import api from "../apiConfig";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
    getAll(data) {
        let params = "";
        if (data) {
            Object.keys(data).forEach(key => {
                params += `${key}=${data[key]}&`;
            });
        }
        return api.get(`/api/v1/notifications?${params}`);
    },
    read(data) {
        return api.post(`/api/v1/notifications/${data.id}`, data);
    },
    delete(id) {
        return api.delete(`/api/v1/notifications/${id}`);
    },
    getById(id) {
        return api.get(`/api/v1/leave-application/${id}`);
    },
}